<template>
  <div class="noticias">
    <v-container class="overflow-y-auto">

        <h1>Noticias</h1>

        <v-layout row>
            <template v-for="(noticia, index) in noticias">
                <v-card min-height="120px" width="93%" class="ma-2 pa-1" v-bind:key="index">
                    <v-card-text >
                        <v-layout row  class="pr-4">
                            <v-flex xs12 md5>
                                <router-link :to="{name:'Noticia', params:{id:5, title:noticia.text}}" class="text-decoration-none">
                                    <v-img
                                        :src="'image/noticias/'+noticia.src"
                                        class="white--text"
                                        >
                                        <span class="my-span">
                                            <v-btn
                                            class="white--text pa-0"
                                            color="error"
                                            small 
                                            >
                                            05Abr
                                            </v-btn>
                                        </span> 
                                    </v-img>
                                </router-link>
                            </v-flex>
                            <v-flex xs12 md7 class="pa-2">
                                <h3 class="pb-2">{{noticia.text}}</h3>
                                <p class="text-justify">
                                    Exercitation consequat eiusmod eu velit labore minim exercitation laborum officia fugiat aliquip dolor cillum incididunt. Aliqua minim id et ipsum. Est velit qui culpa minim consequat consequat velit aute dolore dolore. Commodo culpa sit deserunt non mollit qui tempor Lorem do ex qui. Quis quis commodo adipisicing elit qui commodo sunt do voluptate elit eu in officia.
                                    <router-link to="/noticias" class="text-decoration-none">Leer más...</router-link>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    
                </v-card>
            </template>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
    data(){
        return {
            noticias:[
                    { text:'PRESIDENTE DE LA CORTE DE PUNO SOSTUVO REUNIÓN CON DIRIGENTES DEL SINDICATO DE TRABAJADORES', src:'_1.jpg', link:'#'},
                    { text:'PRESIDENTE DE LA CORTE SUPERIOR DE PUNO JURAMENTÓ COMO INTEGRANTE DEL COMITÉ REGIONAL DE SEGURIDAD CIUDADANA', src:'_2.jpg', link:'#'},
                    { text:'JURAMENTAN MAGISTRADOS PROMOVIDOS A ÓRGANOS JURISDICCIONALES DEL DISTRITO JUDICIAL PUNO', src:'_3.jpg', link:'#'},
                    { text:'EL DOCTOR PÁNFILO MONZÓN MAMANI ASUMIÓ LA PRESIDENCIA DE LA CORTE SUPERIOR DE JUSTICIA DE PUNO PARA EL PERIODO 2021-2022', src:'_4.jpg', link:'#'},
                    { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                    { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
                    { text:'CAPACITAN A JUECES DE PAZ Y AUTORIDADES COMUNALES DEL DISTRITO DE PARATÍA EN LA PROVINCIA DE LAMPA', src:'3.jpg', link:'#'},
                    { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                    { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
                    { text:'CAPACITAN A JUECES DE PAZ Y AUTORIDADES COMUNALES DEL DISTRITO DE PARATÍA EN LA PROVINCIA DE LAMPA', src:'3.jpg', link:'#'},
                    { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                    { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
                    { text:'CAPACITAN A JUECES DE PAZ Y AUTORIDADES COMUNALES DEL DISTRITO DE PARATÍA EN LA PROVINCIA DE LAMPA', src:'3.jpg', link:'#'},
                ]
        }
    }
}
</script>
